import React from 'react';
import PropTypes from 'prop-types';
import styles from './QuestionDisplay.scss';
import themeServices from '../../themes/ThemeServices';

class QuestionRubricBlock extends React.PureComponent {
    static propTypes = {
        question: PropTypes.object,
        choiceModel: PropTypes.object,
    };

    render() {
        const { question, choiceModel } = this.props;
        const questionRubricHTML = themeServices.getThemeInstance().getQuestionRubricsContent(question, choiceModel);

        return questionRubricHTML
            ? <div className={styles.rubricContent} dangerouslySetInnerHTML={{ __html: questionRubricHTML }} />
            : null;
    }
}

export default QuestionRubricBlock;
